import { FormattedMessage } from 'react-intl';

import { Vendor } from 'common/api-types/recommendations';
import { TextLink } from 'common/components/cookbook/TextLink';
import { extractVendorSummary } from 'features/selection-recommendations/Recommendations/DelistingRecommendations/utils';

type VendorsProps = {
  items: Vendor[];
};

export const Vendors = ({ items }: VendorsProps) => {
  if (items.length === 0) return '-';

  const vendorSummary = extractVendorSummary(items);

  const { primaryVendor, otherVendorsCount } = vendorSummary;

  if (otherVendorsCount === 0) {
    return (
      <TextLink
        to="/vendors/$vendorId"
        params={{ vendorId: primaryVendor.vendorId }}
        target="_blank"
      >
        {primaryVendor.vendorName}
      </TextLink>
    );
  }

  const vendors = {
    primaryVendor: (
      <TextLink
        to="/vendors/$vendorId"
        params={{ vendorId: primaryVendor.vendorId }}
        target="_blank"
      >
        {primaryVendor.vendorName}
      </TextLink>
    ),
    count: otherVendorsCount,
  };

  return (
    <div>
      <FormattedMessage id="selection_recommendations.vendors_count" values={vendors} />
    </div>
  );
};
